import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { INoneNegativeCarryoverCreateResponse, INoneNegativeCarryoverPayload } from '../types';
import {
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_API_URL,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_MUTATION,
  AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS,
} from '../constants';

export default function useCreateNoneNegativeCarryoverMutation(): IContextMutationResult<
  INoneNegativeCarryoverCreateResponse,
  Error,
  INoneNegativeCarryoverPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<INoneNegativeCarryoverCreateResponse, Error, INoneNegativeCarryoverPayload>({
    mutationKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_MUTATION],
    mutationFn: (payload) => fetchPost<INoneNegativeCarryoverCreateResponse>(
      AFFILIATE_NONE_NEGATIVE_CARRYOVER_CREATE_API_URL,
      payload,
      {
        permission: AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS.CREATE,
      },
    ),
    onSuccess() {
      displayPresetToast('created');
    },
  });
}
